import { formatAddressCasing } from "./addressCasing";
import { ExternalLinkIcon } from "./ExternalLinkIcon";

// The address as the way through to the row's site. Must agree across the
// /leads inbox and the /leads/search + saved-search results tables, which is
// why it is one component: while each owned a copy, the inbox linked and the
// results table did not. Which kind of site it is lives in the title, not a
// badge - the arrow already says there is one.
export const LeadAddressLink: React.FC<{
  address: string | null;
  // Sites created from this lead (bulk-create). First one wins.
  createdSiteIds?: string[];
  // A platform site the row was matched against, which existed before the lead.
  matchedExistingSiteID?: string | null;
}> = ({ address, createdSiteIds, matchedExistingSiteID }) => {
  const addressText = address ? (
    formatAddressCasing(address)
  ) : (
    <em>(no address)</em>
  );
  const createdSiteId = createdSiteIds?.[0] ?? null;
  const siteId = createdSiteId ?? matchedExistingSiteID ?? null;
  if (!siteId) return <>{addressText}</>;
  return (
    <a
      href={`/site/${siteId}/edit`}
      target="_blank"
      rel="noopener noreferrer"
      // The row is a click target of its own; opening the site must not also
      // re-select the row underneath it.
      onClick={(e) => e.stopPropagation()}
      title={
        createdSiteId
          ? "Open the site created from this lead, in a new tab."
          : "Already on the platform - open the site this row was matched against, in a new tab."
      }
    >
      {addressText}
      <ExternalLinkIcon />
    </a>
  );
};
